import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@arcadeai/design-system/components/ui/atoms/dialog";
import { DateTimePicker } from "@arcadeai/design-system/components/ui/molecules/date-time-picker";
import { useState } from "react";

type CustomDatePickerDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialDate: Date | undefined;
  onConfirm: (date: Date) => void;
};

export const CustomDatePickerDialog = ({
  open,
  onOpenChange,
  initialDate,
  onConfirm,
}: CustomDatePickerDialogProps) => {
  const [tempDate, setTempDate] = useState<Date | undefined>(initialDate);

  const handleCancel = () => {
    onOpenChange(false);
    setTempDate(undefined);
  };

  const handleConfirm = () => {
    if (tempDate) {
      onConfirm(tempDate);
    }
    onOpenChange(false);
    setTempDate(undefined);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Choose Custom Expiration Date</DialogTitle>
          <DialogDescription>
            Select a specific date and time for when this API key should expire.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <DateTimePicker
            disabled={(date) => {
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return date < today;
            }}
            endMonth={new Date(new Date().getFullYear() + 10, 11)}
            onChange={(date) => {
              if (date) {
                setTempDate(date);
              }
            }}
            startMonth={
              new Date(new Date().getFullYear(), new Date().getMonth())
            }
            value={tempDate ?? initialDate}
          />
          <div className="flex justify-end gap-2">
            <Button onClick={handleCancel} type="button" variant="outline">
              Cancel
            </Button>
            <Button onClick={handleConfirm} type="button">
              Confirm
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
